export default __webpack_public_path__ + "static/media/logo.dad61d9a.png";